<template>
  <div class="page-container">
    <div class="title" style="padding-top: 20px; margin-left: 20px">
      <el-button type="primary" style="width: 100px" @click="handleEdit()"
        >修改</el-button
      >
      <span style="margin-left: 20px"
        >该页信息可用于消费者扫商品码时，展示给消费者的，请认真填写。</span
      >
      <!-- <span>预览扫码页面</span> -->
    </div>
    <div class="company-info" style="margin-left: 100px">
      <el-form
        :model="data"
        :rules="rules"
        ref="editForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item label="企业名称" prop="companyInfo.companyName">
          <el-col :span="8">
            <el-input
              v-model="data.companyInfo.companyName"
              placeholder="请输入企业名称"
              :disabled="editStatus"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="企业简称" prop="companyInfo.shortName">
          <el-col :span="8">
            <el-input
              v-model="data.companyInfo.shortName"
              placeholder="请输入企业简称"
              :disabled="editStatus"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="企业LOGO" prop="companyInfo.companyLogo">
          <el-upload
            :class="{ disUoloadSty: noneBtnImg1 }"
            class="avatar-uploader"
            action=""
            list-type="picture-card"
            :limit="1"
            :file-list="logoImg"
            :http-request="uploadFile"
            :on-remove="handleDeleteImg1"
            :on-success="handleAvatarSuccess1"
            :on-error="handleError"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
            :disabled="editStatus"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="企业网址" prop="companyInfo.website">
          <el-col :span="8">
            <el-input
              v-model="data.website"
              placeholder="请输入企业网址"
              :disabled="editStatus"
              maxlength="50"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button @click="showInfo = true" v-show="!showInfo"
            >更多信息...</el-button
          >
          <el-button @click="showInfo = false" v-show="showInfo"
            >收起</el-button
          >
        </el-form-item>
        <el-form-item label="社会统一信用代码" v-show="showInfo">
          <el-col :span="8">
            <el-input
              v-model="data.companyCert.certCode"
              placeholder="请输入社会统一信用代码"
              :disabled="editStatus"
              maxlength="50"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="营业执照" v-show="showInfo">
          <el-upload
            :class="{ disUoloadSty: noneBtnImg2 }"
            class="avatar-uploader"
            action=""
            list-type="picture-card"
            :limit="1"
            :file-list="certImg"
            :http-request="uploadFile"
            :on-remove="handleDeleteImg2"
            :on-success="handleAvatarSuccess2"
            :on-error="handleError"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
            :disabled="editStatus"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </el-form-item>
        <el-form-item label="法人" v-show="showInfo">
          <el-col :span="8">
            <el-input
              v-model="data.companyCert.certAuthor"
              placeholder="请填写法人姓名"
              :disabled="editStatus"
              maxlength="50"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="公司地址" v-show="showInfo">
          <el-col :span="8">
            <el-input
              v-model="data.companyInfo.address"
              placeholder="请输入公司地址"
              :disabled="editStatus"
              maxlength="50"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="企业微信公众号">
          <el-upload
            :class="{ disUoloadSty: noneBtnImg3 }"
            class="avatar-uploader"
            action=""
            list-type="picture-card"
            :limit="1"
            :file-list="qrcodeImg"
            :http-request="uploadFile"
            :on-remove="handleDeleteImg3"
            :on-success="handleAvatarSuccess3"
            :on-error="handleError"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
            :disabled="editStatus"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </el-form-item>
        <el-form-item label="企业简介" class="company-introduction">
          <el-col :span="12" v-show="!editStatus">
            <vue-ueditor-wrap
              v-model="data.context"
              :config="myConfig"
              @beforeInit="addCustomDialog"
            ></vue-ueditor-wrap>
          </el-col>
          <el-col :span="12" v-show="editStatus">
            <div v-html="data.context"></div>
          </el-col>
        </el-form-item>
        <el-form-item label="企业轮播图">
          <el-upload
            :class="{ disUoloadSty: noneBtnImg5 }"
            class="avatar-uploader"
            action=""
            list-type="picture-card"
            :limit="5"
            :file-list="bannerList"
            :http-request="uploadFile"
            :on-remove="handleDeleteImg"
            :on-success="handleAvatarSuccess5"
            :on-error="handleError"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
            :disabled="editStatus"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog> -->
        </el-form-item>
        <el-form-item label="企业宣传视频">
          <el-col :span="7">
            <div class="upload-tip">
              <p>视频格式：支持MP4、avi、mov、flv</p>
              <p>视频大小：限制50MB以内</p>
              <p>其他说明：只能上传一个宣传视频</p>
            </div>
            <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :before-upload="beforeUploadVideo"
              :http-request="uploadVideo"
              accept="video/mp4, video/ogg, video/flv, video/avi, video/wmv, video/rmvb, video/mov, video/quicktime"
              :on-change="uploadVideoProcess"
              :on-success="handleVideoSuccess"
              :disabled="editStatus"
            >
              <video
                v-if="data.videoUrl != '' && !videoFlag"
                :src="data.videoUrl"
                class="avatar video-avatar"
                controls="controls"
              >
                您的浏览器不支持视频播放
              </video>
              <i
                v-else-if="data.videoUrl == '' && !videoFlag"
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <el-progress
                v-if="videoFlag == true"
                type="circle"
                v-bind:percentage="videoUploadPercent"
                style="margin-top: 7px"
              ></el-progress>
            </el-upload>
          </el-col>
          <el-col :span="7">
            <div class="upload-tip">
              <p>图片格式：支持jpg、png</p>
              <p>图片大小：限制5MB以内</p>
              <p>其他说明：用于视频播放首页面</p>
            </div>
            <el-upload
              :class="{ disUoloadSty: noneBtnImg4 }"
              class="avatar-uploader"
              action=""
              list-type="picture-card"
              :limit="1"
              :file-list="videoImg"
              :http-request="uploadFile"
              :on-remove="handleDeleteImg4"
              :on-success="handleAvatarSuccess4"
              :on-error="handleError"
              :on-preview="handlePictureCardPreview"
              :before-upload="beforeUpload"
              :disabled="editStatus"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="margin-left: 250px" v-show="!editStatus">
      <el-button style="width: 100px" @click="cancle()">取 消</el-button>
      <el-button type="primary" style="width: 100px" @click="saveEdit()"
        >保 存</el-button
      >
    </div>
    <el-dialog
      title="上传图片"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="500px"
      :modal-append-to-body="false"
      z-index="100"
    >
      <el-upload
        class="upload-demo"
        drag
        accept=".png, .jpg"
        action
        :on-success="uploadImageSuccess"
        :http-request="uploadArticleImage"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          只能上传jpg/png文件，且不超过5M
        </div>
      </el-upload>
    </el-dialog>
    <el-dialog :visible.sync="dialogImgVisible" class="img-dialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyInfo, uploadImage, saveCompanyInfo } from "@/common/api.js";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: { VueUeditorWrap },
  props: {},
  data() {
    return {
      showInfo: false,
      dialogImgVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      editStatus: true,
      data: {
        companyInfo: {
          companyId: "",
          companyName: "",
          shortName: "",
          companyLogo: "",
          address: "",
        },
        website: "",
        wechatOfficialAccountUrl: "",
        context: "",
        slideShow: [],
        videoUrl: "",
        fileUrl: "",
        companyCert: {
          certId: "",
          certCode: "",
          certificateUrl: "",
          certAuthor: "",
        },
      },
      rules: {
        "companyInfo.companyName": [
          {
            required: true,
            validator: this.testCompanyName,
            trigger: "change",
          },
        ],
        "companyInfo.shortName": [
          {
            required: true,
            validator: this.testCompanyShortName,
            trigger: "change",
          },
        ],
        "companyInfo.companyLogo": [
          { required: true, message: "请上传企业Logo", trigger: "change" },
        ],
      },
      logoImg: [],
      certImg: [],
      qrcodeImg: [],
      videoImg: [],
      bannerList: [],
      bannerSlide: [],
      noneBtnImg1: true,
      noneBtnImg2: true,
      noneBtnImg3: true,
      noneBtnImg4: true,
      noneBtnImg5: true,
      imageUrl: "",
      videoUploadPercent: "",
      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
        showVideoPath: "",
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/static/UEditor/",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    addCustomDialog(editorId) {
      let that = this;
      window.UE.registerUI(
        "test-dialog",
        function (editor, uiName) {
          console.log(editor, uiName);
          // 参考http://ueditor.baidu.com/doc/#COMMAND.LIST
          var btn = new window.UE.ui.Button({
            name: "dialog-button",
            title: "上传图片",
            cssRules: `background-position: -381px 0`,
            onclick: function () {
              // 渲染dialog
              that.dialogVisible = true;
              editor.execCommand(uiName);
            },
          });
          return btn;
        },
        100 /* 指定添加到工具栏上的那个位置，默认时追加到最后 */,
        editorId /* 指定这个UI是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */
      );
    },
    getCompanyInfo() {
      getCompanyInfo().then((res) => {
        if (res.errorCode == 200) {
          if (res.slideShow && JSON.parse(res.slideShow).length > 0) {
            this.bannerList = [];
            JSON.parse(res.slideShow).forEach((item) => {
              this.bannerList.push({ url: item });
              this.bannerSlide.push(item);
            });
          }
          this.logoImg = [];
          this.certImg = [];
          this.qrcodeImg = [];
          this.videoImg = [];
          if (res.companyCert && res.companyCert.certificateUrl) {
            this.certImg.push({ url: res.companyCert.certificateUrl });
          } else {
            this.noneBtnImg2 = false;
          }
          if (res.companyInfo && res.companyInfo.companyLogo) {
            this.logoImg.push({ url: res.companyInfo.companyLogo });
          } else {
            this.noneBtnImg1 = false;
          }
          if (res.wechatOfficialAccountUrl) {
            this.qrcodeImg.push({ url: res.wechatOfficialAccountUrl });
          } else {
            this.noneBtnImg3 = false;
          }
          if (res.fileUrl) {
            this.videoImg.push({ url: res.fileUrl });
          } else {
            this.noneBtnImg4 = false;
          }
          this.data = {
            companyInfo: {
              companyId: res.companyId?res.companyId:"",
              companyName: res.companyInfo?res.companyInfo.companyName:"",
              shortName: res.companyInfo?res.companyInfo.shortName:"",
              companyLogo: res.companyInfo?res.companyInfo.companyLogo:"",
              address: res.companyInfo?res.companyInfo.address:"",
            },
            website: res.website? res.website : "",
            wechatOfficialAccountUrl: res.wechatOfficialAccountUrl? res.wechatOfficialAccountUrl : "",
            context: res.context? res.context : "",
            slideShow: res.slideShow ? JSON.parse(res.slideShow) : [],
            videoUrl: res.videoUrl? res.videoUrl : "",
            fileUrl: res.fileUrl? res.companyCert.fileUrl : "",
            companyCert: {
              certId: res.companyCert ? res.companyCert.certId : "",
              certCode: res.companyCert ? res.companyCert.certCode : "",
              certificateUrl: res.companyCert
                ? res.companyCert.certificateUrl
                : "",
              certAuthor: res.companyCert ? res.companyCert.certAuthor : "",
            },
          };
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    saveEdit() {
      console.log(this.data);
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.data.slideShow = JSON.stringify(this.bannerSlide);
          var params = this.data;
          saveCompanyInfo(params).then((res) => {
            if (res.errorCode == 200) {
              this.editStatus = true;
              this.$message({
                type: "success",
                message: "保存成功",
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    testCompanyName(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入企业名称"));
      }
    },
    testCompanyShortName(rule, value, callback) {
      if (value) {
        if (value.length > 10) {
          callback(new Error("最多输入10个字符"));
        }
        var str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入企业简称"));
      }
    },
    handleEdit() {
      this.editStatus = false;
      this.noneBtnImg5 = false;
    },
    cancle() {
      this.editStatus = true;
      this.noneBtnImg5 = this.noneBtnImg1 = true;
      this.getCompanyInfo();
    },
    // 上传图片
    uploadFile(file) {
      let formDatas = new FormData();
      formDatas.append("businessLicence", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.errorCode == 200) {
          file.onSuccess(res);
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgVisible = true;
    },
    //企业logo
    handleAvatarSuccess1(res, file, fileList) {
      console.log(res);
      this.noneBtnImg1 = fileList.length == 1;
      this.data.companyInfo.companyLogo = res.url;
    },
    handleDeleteImg1(file, fileList) {
      console.log(fileList);
      this.noneBtnImg1 = fileList.length == 1;
      this.data.companyInfo.companyLogo = "";
    },
    //营业执照
    handleAvatarSuccess2(res, file, fileList) {
      console.log(res);
      this.noneBtnImg2 = fileList.length == 1;
      this.data.companyCert.certificateUrl = res.url;
    },
    handleDeleteImg2(file, fileList) {
      console.log(fileList);
      this.noneBtnImg2 = fileList.length == 1;
      this.data.companyCert.certificateUrl = "";
    },
    //微信公众号
    handleAvatarSuccess3(res, file, fileList) {
      this.noneBtnImg3 = fileList.length == 1;
      console.log(this.noneBtnImg3);
      this.data.wechatOfficialAccountUrl = res.url;
    },
    handleDeleteImg3(file, fileList) {
      console.log(fileList);
      this.noneBtnImg3 = fileList.length == 1;
      this.data.wechatOfficialAccountUrl = "";
    },
    //视频封面图片
    handleAvatarSuccess4(res, file, fileList) {
      this.noneBtnImg4 = fileList.length == 1;
      this.data.fileUrl = res.url;
    },
    handleDeleteImg4(file, fileList) {
      console.log(fileList);
      this.noneBtnImg4 = fileList.length == 1;
      this.data.fileUrl = "";
    },
    //企业轮播图
    handleAvatarSuccess5(res, file, fileList) {
      console.log(fileList.length);
      this.noneBtnImg5 = fileList.length == 5;
      if (res.errorCode == 200) {
        this.bannerSlide.push(res.url);
      }
    },
    handleError(err, file, fileList) {
      this.$message.error(err);
    },
    // 删除轮播图片
    handleDeleteImg(file, fileList) {
      this.noneBtnImg5 = fileList.length == 5;
      if (file.response && file.response.url) {
        for (var i = 0; i < this.bannerSlide.length; i++) {
          if (this.bannerSlide[i] == file.response.url) {
            this.bannerSlide.splice(i, 1);
          }
        }
      } else {
        for (var i = 0; i < this.bannerSlide.length; i++) {
          if (this.bannerSlide[i] == file.url) {
            this.bannerSlide.splice(i, 1);
          }
        }
      }
    },
    beforeUpload(file) {
      console.log(file)
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是JPG或PNG格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    // 富文本图片上传
    uploadImageSuccess(response, file, fileList) {
      if (response) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        console.log(file);
        let fileObj = {
          name: file.name,
          url: file.response,
        };
        this.insertUe(fileObj);
      } else {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
      }
    },
    uploadArticleImage(file) {
      let formDatas = new FormData();
      formDatas.append("businessLicence", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.errorCode == 200) {
          file.onSuccess(res.url);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    insertUe(file) {
      console.log(file);
      let editor = document.querySelector(".edui-default").getAttribute("id");
      console.log(editor);
      window.UE.getEditor(editor).execCommand("insertimage", {
        src: file.url,
        width: "100",
        height: "100",
      });
      this.dialogVisible = false;
    },
    handleVideoSuccess(res, file, fileList) {
      console.log(res);
    },
    //进度条
    uploadVideoProcess(file, fileList) {
      console.log(file);
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传视频大小不能超过 50MB!");
        return false;
      }
      if (file.status === "ready") {
        this.videoUploadPercent = 0;
        this.videoFlag = true;
        const interval = setInterval(() => {
          if (this.videoUploadPercent >= 99) {
            clearInterval(interval);
            return;
          }
          this.videoUploadPercent += 1;
        }, 300);
      }
      if (file.status === "success") {
        this.videoUploadPercent = 100;
        this.videoFlag = false;
      }
    },
    beforeUploadVideo(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
          "video/quicktime",
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt50M) {
        this.$message.error("上传视频大小不能超过 50MB!");
        return false;
      }
      return true;
    },
    uploadVideo(file) {
      this.videoFlag = true;
      let formDatas = new FormData();
      formDatas.append("businessLicence", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.errorCode == 200) {
          this.videoFlag = false;
          this.videoUploadPercent = 0;
          this.data.videoUrl = res.url;
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getCompanyInfo();
  },
};
</script>
<style lang="less" scoped>
.page-container {
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 10px;
  padding: 0px 10px 20px;
  .title {
    height: 50px;
    line-height: 50px;
  }
  /deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 118px;
    height: 118px;
  }
  /deep/.el-upload--picture-card {
    width: 118px;
    height: 118px;
    line-height: 118px;
  }
  /deep/.uoloadSty .el-upload--picture-card {
    display: inline-block;
  }
  /deep/.disUoloadSty .el-upload--picture-card {
    display: none; /* 上传按钮隐藏 */
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
  }
  .avatar {
    width: 118px;
    height: 118px;
    display: block;
  }
  .upload-tip p {
    height: 20px;
    line-height: 20px;
    overflow: hidden;
  }
  .company-introduction /deep/.el-form-item__content {
    line-height: 1.5 !important;
  }
  .img-dialog /deep/.el-dialog__header {
    padding: 20px 20px 10px;
    background-color: #ffffff;
    border-style: none;
  }
  /deep/.edui-editor {
    z-index: 98 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/scanManage/companyInfo.vue